import {
    Component,
    ViewEncapsulation,
    OnInit,
    OnDestroy,
    HostListener,
    ElementRef,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';

import {
    Router,
    NavigationEnd,
} from '@angular/router';

import { ApiService } from 'app/shared/api.service';

import { TranslocoService } from '@ngneat/transloco';

import {
    CartService,
    CartItem,
} from 'app/core/cart/cart.service';

import { filter } from 'rxjs/operators';

import { Subscription } from 'rxjs';

import { MqttService } from 'app/core/mqtt/mqtt.service';

import Swal from 'sweetalert2';


@Component({
    selector: 'layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements OnInit, OnDestroy {

    isHomePage: boolean = true;

    isEquipmentRentalPage: boolean = false;

    isDropdownOpen: boolean = false;

    isInvitationDropdownOpen: boolean = false;

    isPackageDropdownOpen: boolean = false;

    isMobileMenuOpen: boolean = false;

    readonly mobileServiceLinks = [
        { route: '/videobooth', label: 'nav.videobooth' },
        { route: '/professional-photographer', label: 'nav.professional_documentation' },
        { route: '/smart-ticketing', label: 'nav.smart_ticketing' },
        { route: '/equipment-rental', label: 'nav.equipment_rental' },
        { route: '/event-organizer', label: 'nav.eo' },
    ];

    currentLang: string = 'id';

    isScrolled: boolean = false;
    isPastHero: boolean = false;

    hoveredPhotoboothSlug: string = '';


    private readonly onScrollCapture = (event?: Event): void => {
        this.handleNavbarScroll(event);
    };

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(event?: Event): void {
        this.handleNavbarScroll(event);
    }

    @HostListener('document:scroll', ['$event'])
    onDocumentScroll(event?: Event): void {
        this.handleNavbarScroll(event);
    }

    handleNavbarScroll(event?: Event): void {
        let scrollY = window.scrollY || window.pageYOffset || 0;
        if (!scrollY && document.documentElement) {
            scrollY = document.documentElement.scrollTop;
        }
        if (!scrollY && document.body) {
            scrollY = document.body.scrollTop;
        }
        if (event && event.target && (event.target as HTMLElement).scrollTop) {
            scrollY = Math.max(scrollY, (event.target as HTMLElement).scrollTop);
        }

        if (this.isHomePage) {
            const heroEl = document.querySelector('.hero-section') as HTMLElement;
            if (heroEl) {
                const rect = heroEl.getBoundingClientRect();
                // rect.top < -10 artinya halaman sudah mulai bergerak di-scroll ke bawah
                this.isScrolled = rect.top < -10 || scrollY > 15;
                // rect.bottom <= 80 artinya batas bawah hero sudah menyentuh / melewati navbar
                this.isPastHero = rect.bottom <= 80;
            } else {
                this.isScrolled = scrollY > 15;
                this.isPastHero = scrollY > 550;
            }
        } else {
            this.isScrolled = scrollY > 15;
            this.isPastHero = false;
        }

        try {
            this.cdr.detectChanges();
        } catch (e) {
            this.cdr.markForCheck();
        }
    }

    @HostListener('window:resize', [])
    onWindowResize(): void {
        this.handleNavbarScroll();
    }


    // =========================================================
    // ACTIVE ROUTE
    // =========================================================

    isRouteActive(route: string): boolean {

        const currentUrl =
            this.router.url.split(/[?#]/)[0];

        if (route === '/') {
            return (
                currentUrl === '/' ||
                currentUrl === '' ||
                currentUrl === '/dashboard'
            );
        }

        return (
            currentUrl === route ||
            currentUrl.startsWith(route + '/')
        );
    }

    isDigitalInvitationThemeSelection(): boolean {
        const path = this.router.url.split(/[?#]/)[0];
        const segments = path.split('/').filter(Boolean);

        return segments.length === 3 && segments[0] === 'digital-invitation';
    }

    isCareerJobDetailPage(): boolean {
        const path = this.router.url.split(/[?#]/)[0];
        const segments = path.split('/').filter(Boolean);

        return segments.length > 1 && segments[0] === 'career';
    }


    // =========================================================
    // CART DRAWER STATE
    // =========================================================

    isCartOpen: boolean = false;

    isCartClosing: boolean = false;

    private cartClosingTimeout: any = null;

    cartItems: CartItem[] = [];

    cartToast: CartItem | null = null;

    isCartAnimating: boolean = false;

    totalCartQty: number = 0;

    totalCartAmount: number = 0;

    isCheckoutModalOpen: boolean = false;

    get checkoutGrandTotal(): number {
        return Math.ceil(this.totalCartAmount / 0.993);
    }

    get checkoutAdminFee(): number {
        return this.checkoutGrandTotal - this.totalCartAmount;
    }


    // =========================================================
    // CHECKOUT
    // =========================================================

    checkoutForm = {
        name: '',
        email: '',
        phone: '',
        eventDate: '',
        eventLocation: '',
        bookingType: 'booking',

        paymentOption: 'full',

        dpPercentage: 50,

        negotiationPrice:
            '' as string | number,

        negotiationNotes: '',

        notes: '',
        customDomain: '',
    };


    // =========================================================
    // CART INVOICE
    // =========================================================

    isCartInvoiceModalOpen: boolean = false;

    cartInvoiceData: any = null;


    private cartSubscription?: Subscription;

    private cartOpenSubscription?: Subscription;

    private cartItemAddedSubscription?: Subscription;

    private directCheckoutSubscription?: Subscription;

    private cartToastTimeout?: ReturnType<typeof setTimeout>;

    private cartAnimationTimeout?: ReturnType<typeof setTimeout>;

    private lastCartClickPosition: { x: number; y: number } | null = null;

    private readonly captureCartClick = (event: MouseEvent): void => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const clickable = target.closest<HTMLElement>('button, [role="button"], a, [class*="cursor-pointer"]');
        if (!clickable) {
            return;
        }

        const bounds = clickable.getBoundingClientRect();
        this.lastCartClickPosition = {
            x: bounds.left + bounds.width / 2,
            y: bounds.top + bounds.height / 2,
        };
    };


    category: any[] = [];

    bundlingPackages: any[] = [];


    invitationCategories = [
        {
            id: 'pernikahan',

            name:
                'Undangan Pernikahan',

            short_description:
                'Jadikan pernikahanmu lebih bermakna dengan berbagai pilihan desain yang menarik',
        },

        {
            id: 'acara',

            name:
                'Acara',

            short_description:
                'Rayakan momen istimewa seperti ulang tahun, reuni dan akikah dll dengan undangan digital yang modern',
        },

        {
            id: 'kartu-ucapan',

            name:
                'Kartu Ucapan',

            short_description:
                'Berikan kartu ucapan di hari yang spesial seperti idul fitri, natal, dan imlek dll sebagai doa serta harapan kepada orang tercinta',
        },
    ];


    // =========================================================
    // CAROUSEL
    // =========================================================

    currentSlide: number = 0;

    autoSlideInterval: any;

    isSliding: boolean = false;


    slidesId = [
        {
            image: '/assets/visidea/digital-invitation.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/gate.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/360.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/guestbook.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/photobooth.MOV',
            description: '',
        },
    ];

    slidesEn = [
        {
            image: '/assets/visidea/digital-invitation.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/gate.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/360.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/guestbook.MOV',
            description: '',
        },
        {
            image: '/assets/visidea/photobooth.MOV',
            description: '',
        },
    ];


    slides = this.slidesId;


    @ViewChild('heroVideo')
    set heroVideo(
        videoRef:
            ElementRef<HTMLVideoElement> | undefined
    ) {

        if (videoRef?.nativeElement) {
            this.playVideoElement(
                videoRef.nativeElement
            );
        }
    }


    // =========================================================
    // VIDEO
    // =========================================================

    isVideo(
        mediaPath?: string
    ): boolean {

        if (!mediaPath) {
            return false;
        }

        const lower =
            mediaPath.toLowerCase();

        return (
            lower.endsWith('.mov') ||
            lower.endsWith('.mp4') ||
            lower.endsWith('.webm') ||
            lower.endsWith('.ogg')
        );
    }


    playVideo(
        event?: any
    ): void {

        const video =
            event?.target ||
            (
                document.querySelector(
                    '.hero-section video'
                ) as HTMLVideoElement
            );

        if (video) {
            this.playVideoElement(video);
        }
    }


    private playVideoElement(
        video: HTMLVideoElement
    ): void {

        video.muted = true;

        video.defaultMuted = true;

        video.playsInline = true;

        const playPromise =
            video.play();

        if (
            playPromise !== undefined
        ) {

            playPromise.catch(() => {

                video.muted = true;

                video
                    .play()
                    .catch(() => { });
            });
        }
    }


    // =========================================================
    // CONSTRUCTOR
    // =========================================================

    constructor(
        private router: Router,

        private apiService: ApiService,

        private translocoService:
            TranslocoService,

        private elementRef:
            ElementRef,

        public cartService:
            CartService,

        private mqttService:
            MqttService,

        private cdr:
            ChangeDetectorRef,
    ) {

        const savedLang =
            localStorage.getItem(
                'selected_language'
            ) ||
            this.translocoService
                .getActiveLang() ||
            'id';

        this.currentLang =
            savedLang;

        this.updateSlides();


        // Detect route pertama kali
        this.checkRoute(
            this.router.url
        );


        // Detect perubahan route
        this.router.events
            .pipe(
                filter(
                    event =>
                        event instanceof
                        NavigationEnd
                )
            )
            .subscribe(
                (
                    event:
                        NavigationEnd
                ) => {

                    this.checkRoute(
                        event.urlAfterRedirects
                    );

                    this.isDropdownOpen =
                        false;

                    this.isInvitationDropdownOpen =
                        false;

                    this.isPackageDropdownOpen =
                        false;

                    this.isMobileMenuOpen =
                        false;


                    if (
                        typeof window !==
                        'undefined'
                    ) {

                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'instant',
                        });

                        document
                            .documentElement
                            .scrollTop = 0;

                        document
                            .body
                            .scrollTop = 0;
                    }
                }
            );
    }


    // =========================================================
    // INIT
    // =========================================================

    ngOnInit(): void {
        this.handleNavbarScroll();

        window.addEventListener('scroll', this.onScrollCapture, true);
        document.addEventListener('scroll', this.onScrollCapture, true);
        if (typeof document !== 'undefined' && document.body) {
            document.body.addEventListener('scroll', this.onScrollCapture, true);
        }

        setTimeout(() => this.handleNavbarScroll(), 100);
        setTimeout(() => this.handleNavbarScroll(), 400);

        document.addEventListener('click', this.captureCartClick, true);

        this.startAutoSlide();

        this.fetchVideoBanners();

        this.fetchProductCategories();

        this.getCategory();

        this.getBundlingPackages();


        this.cartSubscription =
            this.cartService
                .items$
                .subscribe(
                    items => {

                        this.cartItems =
                            items || [];

                        this.totalCartQty =
                            this.cartService
                                .totalQty;

                        this.totalCartAmount =
                            this.cartService
                                .totalAmount;
                    }
                );


        this.cartOpenSubscription =
            this.cartService
                .isCartOpen$
                .subscribe(
                    isOpen => {
                        if (isOpen) {
                            if (this.cartClosingTimeout) {
                                clearTimeout(this.cartClosingTimeout);
                                this.cartClosingTimeout = null;
                            }
                            this.isCartClosing = false;
                            this.isCartOpen = true;
                            this.cartToast = null;
                            clearTimeout(this.cartToastTimeout);
                        } else {
                            if (this.isCartOpen && !this.isCartClosing) {
                                this.isCartClosing = true;
                                if (this.cartClosingTimeout) {
                                    clearTimeout(this.cartClosingTimeout);
                                }
                                this.cartClosingTimeout = setTimeout(() => {
                                    this.isCartOpen = false;
                                    this.isCartClosing = false;
                                    this.cartClosingTimeout = null;
                                }, 280);
                            } else if (!this.isCartClosing) {
                                this.isCartOpen = false;
                            }
                        }
                    }
                );

        this.cartItemAddedSubscription =
            this.cartService
                .itemAdded$
                .subscribe(item => this.showCartAddedToast(item));

        this.directCheckoutSubscription = this.cartService.directCheckout$.subscribe(() => {
            this.isCheckoutModalOpen = true;
        });
    }


    // =========================================================
    // LANGUAGE
    // =========================================================

    setLanguage(
        lang: string
    ): void {

        if (
            this.currentLang === lang
        ) {
            return;
        }

        this.currentLang =
            lang;

        this.translocoService
            .setActiveLang(lang);

        localStorage.setItem(
            'selected_language',
            lang
        );

        this.updateSlides();
    }


    updateSlides(): void {

        this.slides =
            this.currentLang === 'en'
                ? this.slidesEn
                : this.slidesId;
    }


    // =========================================================
    // DESTROY
    // =========================================================

    ngOnDestroy(): void {

        this.stopAutoSlide();

        if (
            this.cartSubscription
        ) {
            this.cartSubscription
                .unsubscribe();
        }

        if (
            this.cartOpenSubscription
        ) {
            this.cartOpenSubscription
                .unsubscribe();
        }

        this.cartItemAddedSubscription?.unsubscribe();
        this.directCheckoutSubscription?.unsubscribe();
        clearTimeout(this.cartToastTimeout);
        clearTimeout(this.cartAnimationTimeout);
        if (this.cartClosingTimeout) {
            clearTimeout(this.cartClosingTimeout);
        }
        document.removeEventListener('click', this.captureCartClick, true);
        window.removeEventListener('scroll', this.onScrollCapture, true);
        document.removeEventListener('scroll', this.onScrollCapture, true);
        if (typeof document !== 'undefined' && document.body) {
            document.body.removeEventListener('scroll', this.onScrollCapture, true);
        }
    }


    // =========================================================
    // PRODUCT CATEGORY
    // =========================================================

    productCategories:
        any[] = [];

    photoboothProducts:
        any[] = [];


    async fetchVideoBanners(): Promise<void> {
        try {
            const apiEndpoint = '/api/v1/front/public/showcases/list?type=video_banner';
            let response: any = await this.apiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev fallback error for showcases:', e);
                }
            }

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response?.list)) {
                rawList = response.list;
            }

            if (rawList && rawList.length > 0) {
                const activeVideos = rawList
                    .filter((item: any) => item.is_active !== false && item.asset?.url)
                    .sort((a: any, b: any) => {
                        const orderA = a.sort_order !== undefined && a.sort_order !== null && a.sort_order !== '' ? Number(a.sort_order) : 9999;
                        const orderB = b.sort_order !== undefined && b.sort_order !== null && b.sort_order !== '' ? Number(b.sort_order) : 9999;
                        if (orderA !== orderB) return orderA - orderB;
                        return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
                    });

                if (activeVideos.length > 0) {
                    const mappedSlides = activeVideos.map((item: any) => ({
                        image: item.asset.url,
                        title: '',
                        description: '',
                        link_url: item.link_url || '',
                        cta_text: item.cta_text || '',
                        id: item.id
                    }));

                    this.slidesId = mappedSlides;
                    this.slidesEn = mappedSlides;
                    this.slides = mappedSlides;
                    if (this.currentSlide >= mappedSlides.length) {
                        this.currentSlide = 0;
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching video banners from showcases:', error);
        }
    }

    async fetchProductCategories():
        Promise<void> {

        try {

            const apiEndpoint =
                '/api/v1/front/public/product-categories/list';

            let response =
                await this.apiService.get(
                    apiEndpoint,
                    false
                );


            if (
                !response ||
                !response.success ||
                !response.data?.list
            ) {

                try {

                    const devRes =
                        await fetch(
                            `https://dev.api.visideastudio.com${apiEndpoint}`
                        );

                    if (
                        devRes.ok
                    ) {

                        response =
                            await devRes.json();
                    }

                } catch (e) {

                    console.error(
                        'Dev API fallback error for product-categories:',
                        e
                    );
                }
            }


            if (
                response &&
                response.data
            ) {

                let rawList:
                    any[] = [];


                if (
                    Array.isArray(
                        response.data.list
                    )
                ) {

                    rawList =
                        response.data.list;

                } else if (
                    Array.isArray(
                        response.data
                    )
                ) {

                    rawList =
                        response.data;

                } else if (
                    Array.isArray(
                        response
                    )
                ) {

                    rawList =
                        response;
                }


                if (
                    rawList.length > 0
                ) {

                    this.productCategories =
                        rawList.sort(
                            (
                                a: any,
                                b: any
                            ) => {

                                const orderA =
                                    a.short_order !==
                                        undefined
                                        ? a.short_order
                                        : (
                                            a.shirt_order !==
                                                undefined
                                                ? a.shirt_order
                                                : 99
                                        );


                                const orderB =
                                    b.short_order !==
                                        undefined
                                        ? b.short_order
                                        : (
                                            b.shirt_order !==
                                                undefined
                                                ? b.shirt_order
                                                : 99
                                        );


                                return (
                                    orderA -
                                    orderB
                                );
                            }
                        );

                    return;
                }
            }

        } catch (error) {

            console.error(
                'Error fetching product categories:',
                error
            );
        }


        this.productCategories = [

            {
                id:
                    '155630e5-3262-4f0d-8322-8f4d82747250',

                name:
                    'digital invitation',

                description:
                    null,

                short_order: 0,

                shirt_order: 0,
            },

            {
                id:
                    'b8f9604a-b57f-4457-a492-3e1cca53f3d1',

                name:
                    'digital guest book',

                description:
                    null,

                short_order: 1,

                shirt_order: 1,
            },

            {
                id:
                    'ae5ae08e-4a14-4dc3-893b-10b27e6711ff',

                name:
                    'photobooth',

                description:
                    null,

                short_order: 2,

                shirt_order: 2,
            },

            {
                id:
                    '3b3ae83d-b1b0-4173-9af1-4c597e7f4302',

                name:
                    'videobooth',

                description:
                    null,

                short_order: 3,

                shirt_order: 3,
            },

            {
                id:
                    '01a0ccf4-b852-7239-9733-5f342a9d30c9',

                name:
                    'Professional Documentation',

                description:
                    null,

                short_order: 4,

                shirt_order: 4,
            },

            {
                id:
                    '01a0ccf5-0a9a-7362-a97e-582c08e89f1d',

                name:
                    'Smart Ticketing',

                description:
                    null,

                short_order: 5,

                shirt_order: 5,
            },

            {
                id:
                    '01a0ccf5-6426-706c-8e50-d9c949e98c19',

                name:
                    'Equipment Rental',

                description:
                    null,

                short_order: 6,

                shirt_order: 6,
            },
        ];
    }


    // =========================================================
    // PHOTOOBOOTH PRODUCT
    // =========================================================

    async getCategory():
        Promise<void> {

        try {

            const apiEndpoint =
                '/api/v1/front/public/non-themed-products/list';

            let response =
                await this.apiService.get(
                    apiEndpoint,
                    false
                );


            if (
                !response ||
                !response.success ||
                !response.data?.list
            ) {

                try {

                    const devRes =
                        await fetch(
                            `https://dev.api.visideastudio.com${apiEndpoint}`
                        );

                    if (
                        devRes.ok
                    ) {

                        response =
                            await devRes.json();
                    }

                } catch (e) {

                    console.error(
                        'Dev API fallback error for non-themed-products:',
                        e
                    );
                }
            }


            let rawList:
                any[] = [];


            if (
                response &&
                response.data
            ) {

                if (
                    Array.isArray(
                        response.data.list
                    )
                ) {

                    rawList =
                        response.data.list;

                } else if (
                    Array.isArray(
                        response.data
                    )
                ) {

                    rawList =
                        response.data;
                }

            } else if (
                Array.isArray(
                    response
                )
            ) {

                rawList =
                    response;
            }


            const photobooths =
                rawList.filter(
                    (item: any) => {

                        const catName =
                            String(
                                item.product_category_name ||
                                item.product_category?.name ||
                                item.category ||
                                ''
                            )
                                .toLowerCase();


                        const name =
                            String(
                                item.name ||
                                ''
                            )
                                .toLowerCase();


                        return (
                            catName.includes(
                                'photo'
                            ) ||
                            name.includes(
                                'hype'
                            ) ||
                            name.includes(
                                'poppy'
                            ) ||
                            name.includes(
                                'vintage'
                            )
                        );
                    }
                );


            if (
                photobooths.length > 0
            ) {

                this.category =
                    photobooths.map(
                        (item: any) => {

                            const rawName =
                                String(
                                    item.name ||
                                    ''
                                )
                                    .trim();


                            let formattedName =
                                rawName;


                            if (
                                !formattedName
                                    .toLowerCase()
                                    .includes(
                                        'photobooth'
                                    )
                            ) {

                                formattedName =
                                    `${formattedName
                                        .charAt(0)
                                        .toUpperCase()
                                    }${formattedName
                                        .slice(1)
                                    } Photobooth`;

                            } else {

                                formattedName =
                                    formattedName
                                        .charAt(0)
                                        .toUpperCase() +
                                    formattedName
                                        .slice(1);
                            }


                            const slug =
                                (
                                    item.slug ||
                                    rawName
                                        .toLowerCase()
                                        .replace(
                                            /\s+/g,
                                            '-'
                                        )
                                )
                                    .trim();


                            let desc =
                                item.short_description ||
                                item.description;


                            if (
                                !desc ||
                                desc ===
                                `photobooth ${rawName.toLowerCase()}`
                            ) {

                                if (
                                    slug.includes(
                                        'hype'
                                    )
                                ) {

                                    desc =
                                        'Photobooth dengan gaya kasual dan penuh warna untuk berbagai event seperti birthday, festival, dan gathering.';

                                } else if (
                                    slug.includes(
                                        'poppy'
                                    )
                                ) {

                                    desc =
                                        'Photobooth estetik & stylish dengan frame modern untuk mengabadikan momen berharga.';

                                } else if (
                                    slug.includes(
                                        'vintage'
                                    )
                                ) {

                                    desc =
                                        'Nuansa klasik elegan bernuansa retro premium untuk pernikahan dan perayaan istimewa.';

                                } else {

                                    desc =
                                        `Layanan photobooth ${rawName} interaktif dan eksklusif dari Visidea Studio.`;
                                }
                            }


                            return {
                                id:
                                    item.id,

                                name:
                                    formattedName,

                                rawName,

                                slug,

                                short_description:
                                    desc,

                                description:
                                    item.description,

                                images:
                                    item.images ||
                                    [],

                                packages:
                                    item.packages ||
                                    [],

                                rawApiData:
                                    item,
                            };
                        }
                    );


                this.photoboothProducts =
                    [
                        ...this.category,
                    ];

            } else {

                this
                    .setFallbackPhotoboothList();
            }

        } catch (error) {

            console.error(
                'Error fetching non-themed photobooth products:',
                error
            );

            this
                .setFallbackPhotoboothList();
        }
    }


    private setFallbackPhotoboothList():
        void {

        this.category = [

            {
                id:
                    '86301024-15fb-4525-bc23-973a9b946558',

                name:
                    'Hypee Photobooth',

                rawName:
                    'hypee',

                slug:
                    'hyppe-photobooth',

                short_description:
                    'Photobooth dengan gaya kasual dan penuh warna untuk berbagai event seperti birthday, festival, dan gathering.',
            },

            {
                id:
                    '0590ff0b-6144-4541-86a0-8558a6a690bb',

                name:
                    'Poppy Photobooth',

                rawName:
                    'poppy',

                slug:
                    'poppy-photobooth',

                short_description:
                    'Photobooth estetik & stylish dengan frame modern untuk mengabadikan momen berharga.',
            },

            {
                id:
                    'e4874cb8-7c5f-4965-afd3-76c8a03fb857',

                name:
                    'Vintage Photobooth',

                rawName:
                    'vintage',

                slug:
                    'vintage-photobooth',

                short_description:
                    'Nuansa klasik elegan bernuansa retro premium untuk pernikahan dan perayaan istimewa.',
            },
        ];


        this.photoboothProducts =
            [
                ...this.category,
            ];
    }


    // =========================================================
    // PACKAGE
    // =========================================================

    async getBundlingPackages():
        Promise<void> {

        try {

            const apiEndpoint =
                '/api/v1/front/public/bundling-packages/list?paginate=false&search=&page=&per_page=';


            let response =
                await this.apiService.get(
                    apiEndpoint,
                    false
                );


            if (
                !response ||
                !response.success ||
                !response.data?.list
            ) {

                try {

                    const devRes =
                        await fetch(
                            `https://dev.api.visideastudio.com${apiEndpoint}`
                        );

                    if (
                        devRes.ok
                    ) {

                        response =
                            await devRes.json();
                    }

                } catch (e) {

                    console.error(
                        'Dev API fallback error in navbar:',
                        e
                    );
                }
            }


            if (
                response &&
                response.data
            ) {

                if (
                    Array.isArray(
                        response.data.list
                    )
                ) {

                    this.bundlingPackages =
                        response.data.list;

                } else if (
                    Array.isArray(
                        response.data
                    )
                ) {

                    this.bundlingPackages =
                        response.data;
                }
            }

        } catch (error) {

            console.error(
                'Error fetching bundling packages for navbar:',
                error
            );
        }
    }


    // =========================================================
    // DROPDOWN
    // =========================================================

    togglePackageDropdown(
        event?: Event
    ): void {

        if (event) {
            event.stopPropagation();
        }

        this.isPackageDropdownOpen =
            !this.isPackageDropdownOpen;


        if (
            this.isPackageDropdownOpen
        ) {

            this.isDropdownOpen =
                false;

            this.isInvitationDropdownOpen =
                false;
        }
    }


    closeDropdown(): void {

        this.isDropdownOpen =
            false;

        this.isInvitationDropdownOpen =
            false;

        this.isPackageDropdownOpen =
            false;
    }


    @HostListener(
        'document:click',
        ['$event']
    )
    onDocumentClick(
        event: MouseEvent
    ): void {

        if (
            !this.elementRef
                .nativeElement
                .contains(
                    event.target
                )
        ) {

            this.isDropdownOpen =
                false;

            this.isInvitationDropdownOpen =
                false;

            this.isPackageDropdownOpen =
                false;
        }
    }


    // =========================================================
    // CHECK ROUTE
    // =========================================================

    private checkRoute(
        url: string
    ): void {

        const cleanUrl =
            url.split(/[?#]/)[0];


        this.isEquipmentRentalPage =
            cleanUrl ===
            '/equipment-rental';


        this.isHomePage =
            cleanUrl === '/' ||
            cleanUrl === '' ||
            cleanUrl ===
            '/dashboard';
    }


    // =========================================================
    // PHOTOOBOOTH DROPDOWN
    // =========================================================

    toggleDropdown(
        event?: Event
    ): void {

        if (event) {
            event.stopPropagation();
        }

        this.isDropdownOpen =
            !this.isDropdownOpen;


        if (
            this.isDropdownOpen
        ) {

            this.isInvitationDropdownOpen =
                false;

            this.isPackageDropdownOpen =
                false;
        }
    }


    toggleInvitationDropdown(
        event?: Event
    ): void {

        if (event) {
            event.stopPropagation();
        }

        this.isInvitationDropdownOpen =
            !this.isInvitationDropdownOpen;


        if (
            this.isInvitationDropdownOpen
        ) {

            this.isDropdownOpen =
                false;

            this.isPackageDropdownOpen =
                false;
        }
    }


    // =========================================================
    // MOBILE MENU
    // =========================================================

    toggleMobileMenu(): void {

        this.isMobileMenuOpen =
            !this.isMobileMenuOpen;

        this.isDropdownOpen =
            false;

        this.isInvitationDropdownOpen =
            false;

        this.isPackageDropdownOpen =
            false;
    }


    @HostListener(
        'document:keydown.escape'
    )
    closeMobileMenu(): void {

        if (
            !this.isMobileMenuOpen
        ) {
            return;
        }

        this.isMobileMenuOpen =
            false;

        this.isDropdownOpen =
            false;
    }


    @HostListener(
        'window:resize'
    )
    onNavigationResize(): void {

        const desktopWidth =
            this.isEquipmentRentalPage
                ? 900
                : 1280;

        if (
            window.innerWidth >=
            desktopWidth
        ) {
            this.closeMobileMenu();
        }
    }


    // =========================================================
    // NAVIGATION
    // =========================================================

    goToPackage(): void {

        this.closeAllNavigation();

        this.router
            .navigate(
                ['/package']
            )
            .then(() => {

                this.scrollTop();
            });
    }

    goToVoucher(): void {

        this.closeAllNavigation();

        this.router
            .navigate(
                ['/voucher']
            )
            .then(() => {

                this.scrollTop();
            });
    }


    goToDigitalInvitation(
        type?: string
    ): void {

        this.closeAllNavigation();

        const route =
            type
                ? [
                    '/digital-invitation',
                    type,
                ]
                : [
                    '/digital-invitation',
                ];


        this.router
            .navigate(route)
            .then(() => {

                this.scrollTop();
            });
    }


    goToPhotobooth(
        item?: any
    ): void {

        this.closeAllNavigation();


        if (
            item &&
            item.slug
        ) {

            this.router
                .navigate([
                    '/photobooth',
                    item.slug,
                ])
                .then(() => {

                    this.scrollTop();
                });

        } else {

            this.router
                .navigate([
                    '/photobooth',
                ])
                .then(() => {

                    this.scrollTop();
                });
        }
    }


    goToHome(): void {

        this.closeAllNavigation();

        this.router
            .navigate([''])
            .then(() => {

                this.scrollTop();
            });
    }


    goBack(): void {

        this.goToHome();
    }


    scrollToPhotoboothSection():
        void {

        this.isDropdownOpen =
            false;

        this.isMobileMenuOpen =
            false;


        if (
            this.isHomePage
        ) {

            this.scrollToSection(
                'photobooth-products'
            );

        } else {

            this.router
                .navigate(['/'])
                .then(() => {

                    setTimeout(
                        () => {

                            this.scrollToSection(
                                'photobooth-products'
                            );
                        },
                        150
                    );
                });
        }
    }


    getDropdownPhotoImage():
        string {

        const slug =
            this.hoveredPhotoboothSlug
                ?.toLowerCase() ||
            '';


        if (
            slug.includes(
                'poppy'
            )
        ) {

            return (
                '/assets/visidea/craftybyul_poppy.png'
            );

        } else if (
            slug.includes(
                'vintage'
            )
        ) {

            return (
                '/assets/visidea/craftybyul_vintage.png'
            );

        } else {

            return (
                '/assets/visidea/craftybyul_hypee.png'
            );
        }
    }


    goToVideobooth(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/videobooth',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToGuestBook(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/guest-book',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToProfessionalPhotographer():
        void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/professional-photographer',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToSmartTicketing():
        void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/smart-ticketing',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToEO(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/event-organizer',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToEquipmentRental():
        void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/equipment-rental',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToCareer(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/career',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToAboutUs(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/about-us',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToPartnership(): void {

        this.closeAllNavigation();

        this.router
            .navigate([
                '/mitra',
            ])
            .then(() => {

                this.scrollTop();
            });
    }


    goToReview(): void {
        this.closeAllNavigation();

        this.router
            .navigate([
                '/review',
            ])
            .then(() => {
                this.scrollTop();
            });
    }

    goToTestimoni(): void {
        this.goToReview();
    }

    goToPortfolio(): void {
        this.closeAllNavigation();

        this.router
            .navigate([
                '/portfolio',
            ])
            .then(() => {
                this.scrollTop();
            });
    }

    goToPortofolio(): void {
        this.goToPortfolio();
    }

    goToEntertaint(): void {
        this.closeAllNavigation();
        const message = encodeURIComponent(
            'Halo Visidea Studio, saya tertarik untuk berkonsultasi mengenai layanan Entertaint. Bisakah saya mendapatkan informasi lebih lanjut?'
        );
        window.open(`https://wa.me/${this.phone}?text=${message}`, '_blank');
    }


    private closeAllNavigation():
        void {

        this.isInvitationDropdownOpen =
            false;

        this.isDropdownOpen =
            false;

        this.isPackageDropdownOpen =
            false;

        this.isMobileMenuOpen =
            false;
    }


    private scrollTop(): void {

        if (
            typeof window ===
            'undefined'
        ) {
            return;
        }

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
        });

        document.documentElement
            .scrollTop = 0;

        document.body
            .scrollTop = 0;
    }


    // =========================================================
    // CART
    // =========================================================

    openCart(): void {

        this.isMobileMenuOpen =
            false;

        this.cartService
            .openCart();
    }


    closeCart(): void {

        this.cartService
            .closeCart();
    }


    toggleCart(): void {

        this.isMobileMenuOpen =
            false;

        this.cartService
            .toggleCart();
    }


    private showCartAddedToast(item: CartItem): void {

        this.animateCartItem(item);
        clearTimeout(this.cartToastTimeout);
        clearTimeout(this.cartAnimationTimeout);

        this.cartToast = null;
        this.isCartAnimating = false;

        if (this.isCartOpen) {
            return;
        }

        setTimeout(() => {
            if (this.isCartOpen) {
                return;
            }

            this.cartToast = item;
            this.isCartAnimating = true;

            this.cartAnimationTimeout = setTimeout(() => {
                this.isCartAnimating = false;
            }, 700);

            this.cartToastTimeout = setTimeout(() => {
                this.cartToast = null;
            }, 4500);
        });
    }


    openCartFromToast(): void {

        this.cartToast = null;
        clearTimeout(this.cartToastTimeout);
        this.cartService.openCart();
    }


    private animateCartItem(item: CartItem): void {

        if (
            !item.image ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
            return;
        }

        const cartButton = Array.from(
            document.querySelectorAll<HTMLElement>('[data-cart-target]')
        ).find(button => button.getClientRects().length > 0);

        if (!cartButton) {
            return;
        }

        const cartBounds = cartButton.getBoundingClientRect();
        const start = this.lastCartClickPosition ?? {
            x: window.innerWidth / 2,
            y: window.innerHeight * 0.65,
        };
        const endX = cartBounds.left + cartBounds.width / 2 - start.x;
        const endY = cartBounds.top + cartBounds.height / 2 - start.y;
        const image = document.createElement('img');

        image.src = item.image;
        image.alt = '';
        image.className = 'cart-flying-image';
        image.style.left = `${start.x - 28}px`;
        image.style.top = `${start.y - 28}px`;
        document.body.appendChild(image);

        const animation = image.animate(
            [
                { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 },
                {
                    transform: `translate3d(${endX * 0.55}px, ${endY * 0.3}px, 0) scale(.82)`,
                    opacity: 1,
                    offset: 0.65,
                },
                { transform: `translate3d(${endX}px, ${endY}px, 0) scale(.18)`, opacity: 0.15 },
            ],
            { duration: 650, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'forwards' }
        );

        animation.onfinish = () => image.remove();
    }


    incrementCartQty(
        item: CartItem
    ): void {

        this.cartService
            .updateQty(
                item.id,
                item.qty + 1
            );
    }


    decrementCartQty(
        item: CartItem
    ): void {

        this.cartService
            .updateQty(
                item.id,
                item.qty - 1
            );
    }


    onCartQtyInput(item: CartItem, event: Event): void {
        const input = event.target as HTMLInputElement;
        const val = input?.value;
        if (!val || val.trim() === '') {
            return;
        }
        const parsed = parseInt(val, 10);
        if (!isNaN(parsed) && parsed >= 1) {
            this.cartService.updateQty(item.id, parsed);
        }
    }


    onCartQtyBlur(item: CartItem, event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input) return;
        const parsed = parseInt(input.value, 10);
        if (isNaN(parsed) || parsed < 1) {
            input.value = '1';
            this.cartService.updateQty(item.id, 1);
        } else {
            input.value = parsed.toString();
            this.cartService.updateQty(item.id, parsed);
        }
    }


    onCartQtyEnter(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input) {
            input.blur();
        }
    }


    removeCartItem(
        item: CartItem
    ): void {

        this.cartService
            .removeItem(
                item.id
            );
    }


    clearCart(): void {

        Swal.fire({
            title:
                'Kosongkan Keranjang?',

            text:
                'Semua item dalam keranjang belanja Anda akan dihapus.',

            icon:
                'warning',

            showCancelButton:
                true,

            confirmButtonColor:
                '#d33',

            cancelButtonColor:
                '#3085d6',

            confirmButtonText:
                'Ya, Kosongkan',

            cancelButtonText:
                'Batal',

        }).then(
            result => {

                if (
                    result.isConfirmed
                ) {

                    this.cartService
                        .clearCart();
                }
            }
        );
    }


    // =========================================================
    // CHECKOUT
    // =========================================================

    hasSmartTicketingInCart(): boolean {
        return this.cartItems.some(item => (item.category || '').toLowerCase().includes('ticket') || (item.name || '').toLowerCase().includes('ticket') || (item.category || '').toLowerCase().includes('undangan') || (item.name || '').toLowerCase().includes('undangan'));
    }

    getSmartTicketingRequestedDomain(): string {
        const item = this.cartItems.find(item => (item.category || '').toLowerCase().includes('ticket') || (item.name || '').toLowerCase().includes('ticket') || (item.category || '').toLowerCase().includes('undangan') || (item.name || '').toLowerCase().includes('undangan'));
        return item?.custom_options?.custom_domain || item?.custom_options?.requested_domain || item?.custom_options?.domain || '';
    }

    openCheckoutModal():
        void {

        if (
            this.cartItems.length ===
            0
        ) {

            Swal.fire({
                icon:
                    'info',

                title:
                    'Keranjang Kosong',

                text:
                    'Silakan pilih dan masukkan produk ke keranjang belanja terlebih dahulu.',
            });

            return;
        }

        this.isCheckoutModalOpen =
            true;
    }


    closeCheckoutModal():
        void {

        this.isCheckoutModalOpen =
            false;
        this.cartService.finishDirectCheckout();
    }


    async submitCartCheckout(): Promise<void> {
        if (
            !this.checkoutForm.name ||
            !this.checkoutForm.phone ||
            !this.checkoutForm.email
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Data Belum Lengkap',
                text: 'Mohon lengkapi Nama Lengkap, Email Aktif, dan No. WhatsApp Anda.',
            });
            return;
        }

        const bookingType: 'FULL_PAYMENT' | 'DOWN_PAYMENT' | 'QUOTATION' =
            this.checkoutForm.paymentOption === 'dp'
                ? 'DOWN_PAYMENT'
                : (this.checkoutForm.paymentOption === 'quotation' ? 'QUOTATION' : 'FULL_PAYMENT');

        const dpPercent = Math.min(
            Math.max(Number(this.checkoutForm.dpPercentage) || 50, 10),
            90
        );

        const checkoutItems = [...this.cartItems];
        const checkoutTotal = this.totalCartAmount;
        const finalCheckoutTotal = Math.ceil(checkoutTotal / 0.993);

        let combinedNotes = this.checkoutForm.notes || this.checkoutForm.negotiationNotes || '';

        Swal.fire({
            title: 'Memproses Pesanan...',
            text: 'Mohon tunggu sebentar',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const now = new Date();
        const formattedDate = new Intl.DateTimeFormat('id-ID', {
            dateStyle: 'full',
            timeStyle: 'short',
        }).format(now);

        let responseData: any = null;
        try {
            const apiRes = await this.cartService.checkout({
                name: this.checkoutForm.name,
                email: this.checkoutForm.email,
                phone: this.checkoutForm.phone,
                event_date: this.checkoutForm.eventDate || undefined,
                event_location: this.checkoutForm.eventLocation || undefined,
                booking_type: bookingType,
                dp_percentage: dpPercent,
                notes: this.checkoutForm.notes || this.checkoutForm.negotiationNotes || undefined,
                custom_domain: this.hasSmartTicketingInCart() ? this.checkoutForm.customDomain?.trim() || undefined : undefined,
            });
            responseData = apiRes?.data;
            Swal.close();
        } catch (err: any) {
            console.warn('API checkout failed, using local fallback:', err);
            Swal.close();
        }

        const order = responseData?.orders?.[0] || responseData?.order;
        const payment = order?.payment || responseData?.payment;
        const invCode = order?.order_code || responseData?.booking_code || ('INV/' + now.getFullYear() + '/VIS-CART-' + Math.random().toString(36).substring(2, 8).toUpperCase());

        const total = responseData?.total_price || finalCheckoutTotal;
        let payAmount = order?.grand_price || total;
        let remainingAmount = responseData?.remaining_amount || 0;
        let paymentTypeLabel = 'Full Payment (100%)';

        if (bookingType === 'DOWN_PAYMENT') {
            paymentTypeLabel = `Down Payment (DP ${dpPercent}%)`;
            payAmount = order?.grand_price || Math.round(total * (dpPercent / 100));
            remainingAmount = responseData?.remaining_amount || (total - payAmount);
        } else if (bookingType === 'QUOTATION') {
            paymentTypeLabel = 'Surat Penawaran Resmi (Custom Quotation)';
            payAmount = 0;
            remainingAmount = checkoutTotal;
        }

        let rawQrString = payment?.qr_code_url || payment?.qr_string || responseData?.qr_code_url || null;
        if (!rawQrString && bookingType !== 'QUOTATION') {
            rawQrString = this.generateDynamicQris(payAmount, invCode);
        }

        let qrCodeUrl = null;
        if (rawQrString) {
            if (rawQrString.startsWith('http') || rawQrString.startsWith('data:image')) {
                qrCodeUrl = rawQrString;
            } else {
                qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&ecc=M&margin=12&data=${encodeURIComponent(rawQrString)}`;
            }
        }

        const isPaymentPending = bookingType !== 'QUOTATION' && (payment?.status || 'pending').toLowerCase() === 'pending';
        const isPaid = (payment?.status || responseData?.status || '').toLowerCase() === 'paid';

        let statusText = 'QUOTATION PROPOSAL';
        if (bookingType !== 'QUOTATION') {
            if (isPaid) {
                statusText = 'PAID / LUNAS (VERIFIED)';
            } else if (bookingType === 'DOWN_PAYMENT') {
                statusText = `MENUNGGU PEMBAYARAN DP (${dpPercent}%)`;
            } else {
                statusText = 'MENUNGGU PEMBAYARAN (PENDING)';
            }
        }

        const bookingCode = responseData?.booking_code || null;
        const refId = payment?.reference_id || null;

        this.cartInvoiceData = {
            invoiceNumber: invCode,
            bookingCode: bookingCode,
            referenceId: refId,
            invoiceDate: formattedDate,
            customerName: this.checkoutForm.name,
            customerEmail: this.checkoutForm.email,
            customerPhone: this.checkoutForm.phone,
            eventDate: this.checkoutForm.eventDate || '-',
            eventLocation: this.checkoutForm.eventLocation || '-',
            notes: combinedNotes || '-',
            smartTicketingDomain: this.hasSmartTicketingInCart() ? this.checkoutForm.customDomain?.trim() : null,
            items: checkoutItems,
            totalAmount: total,
            paymentOption: this.checkoutForm.paymentOption,
            paymentTypeLabel,
            dpPercentage: dpPercent,
            payAmount,
            remainingAmount,
            rawQris: rawQrString,
            qrCodeUrl: qrCodeUrl,
            virtualAccount: payment?.virtual_account || null,
            isPendingPayment: isPaymentPending,
            isPaid: isPaid,
            status: statusText,
        };

        this.cartService.finishDirectCheckout();
        this.isCheckoutModalOpen = false;
        this.isCartOpen = false;
        this.isCartInvoiceModalOpen = true;

        if (isPaymentPending && (bookingCode || refId)) {
            this.startPaymentPolling(bookingCode, refId);
        }
    }

    generateDynamicQris(amount: number, refId: string): string {
        const amountVal = Math.max(1, Math.round(amount));
        const refStr = (refId || 'VIS-PAY-' + Math.random().toString(36).substring(2, 8)).slice(0, 25);
        const xenditBase = '00020101021226650013CO.XENDIT.WWW01189360084800000002760215Yt26zmShYBf7tFG0303UME51370014ID.CO.QRIS.WWW0215ID202435700371252520450995303360';
        const tag54 = `54${String(amountVal.toString().length).padStart(2, '0')}${amountVal}`;
        const tag58 = '5802ID';
        const tag59 = '5926PT Adhikari Inovasi Indon';
        const tag60 = '6007BANDUNG';
        const tag61 = '610540294';
        const tag62Sub05 = `05${String(refStr.length).padStart(2, '0')}${refStr}`;
        const tag62 = `62${String(tag62Sub05.length).padStart(2, '0')}${tag62Sub05}`;
        const payloadBase = `${xenditBase}${tag54}${tag58}${tag59}${tag60}${tag61}${tag62}6304`;

        let crc = 0xffff;
        for (let i = 0; i < payloadBase.length; i++) {
            crc ^= payloadBase.charCodeAt(i) << 8;
            for (let j = 0; j < 8; j++) {
                if ((crc & 0x8000) !== 0) {
                    crc = ((crc << 1) ^ 0x1021) & 0xffff;
                } else {
                    crc = (crc << 1) & 0xffff;
                }
            }
        }
        const crcHex = (crc & 0xffff).toString(16).toUpperCase().padStart(4, '0');
        return `${payloadBase}${crcHex}`;
    }

    isCheckingManualStatus: boolean = false;

    async checkPaymentStatusManual(): Promise<void> {
        const bookingCode = this.cartInvoiceData?.bookingCode;
        if (!bookingCode) return;
        this.isCheckingManualStatus = true;

        try {
            const url = `/api/v1/front/public/checkout/bookings/${bookingCode}`;
            const res: any = await this.apiService.get(url, false);
            const data = res?.data;

            if (data) {
                const bStatus = String(data.status || '').toLowerCase();
                const oStatus = String(data.orders?.[0]?.status || '').toLowerCase();
                const pStatus = String(data.orders?.[0]?.payments?.[0]?.status || '').toLowerCase();
                const totalPaid = Number(data.total_paid || 0);

                const isPaidSuccess =
                    totalPaid > 0 ||
                    ['paid', 'fully_paid', 'success', 'completed'].includes(bStatus) ||
                    ['paid', 'success', 'completed'].includes(oStatus) ||
                    ['paid', 'success', 'completed'].includes(pStatus);

                if (isPaidSuccess) {
                    if (this.cartInvoiceData) {
                        this.cartInvoiceData.isPaid = true;
                        this.cartInvoiceData.isPendingPayment = false;
                        this.cartInvoiceData.status = (bStatus === 'partially_paid' || totalPaid < (this.cartInvoiceData.totalAmount || 0)) ? 'PARTIALLY PAID / DP LUNAS' : 'PAID / LUNAS (VERIFIED)';
                    }
                    this.stopPaymentPolling();
                    Swal.fire({
                        icon: 'success',
                        title: 'Pembayaran Lunas!',
                        text: 'Pembayaran Anda telah berhasil diverifikasi oleh sistem.',
                        timer: 3000,
                        showConfirmButton: false,
                    });
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: 'Status Belum Berubah',
                        text: 'Pembayaran belum terdeteksi di sistem. Jika Anda sudah membayar, silakan tunggu beberapa saat.',
                        timer: 2500,
                        showConfirmButton: false,
                    });
                }
            }
        } catch (err) {
            console.error('Manual status check error:', err);
        } finally {
            this.isCheckingManualStatus = false;
        }
    }

    private cartMqttSubscription?: Subscription;

    subscribeCartPaymentMqtt(bookingCode?: string, referenceId?: string): void {
        if (!bookingCode && !referenceId) return;

        try {
            console.log(`🔌 Subscribing to MQTT for payment: booking=${bookingCode}, ref=${referenceId}`);
            this.mqttService.connect();

            const topics: string[] = ['qr.payment'];
            if (bookingCode) {
                topics.push(bookingCode);
                topics.push(`booking/${bookingCode}`);
                topics.push(`checkout/${bookingCode}`);
            }
            if (referenceId) {
                topics.push(referenceId);
                topics.push(`payment/${referenceId}`);
                topics.push(`qris/${referenceId}`);
            }

            topics.forEach((t) => this.mqttService.subscribe(t));

            if (this.cartMqttSubscription) {
                this.cartMqttSubscription.unsubscribe();
            }

            this.cartMqttSubscription = this.mqttService.messages$.subscribe(({ topic, message }) => {
                console.log(`📡 MQTT event received on [${topic}]:`, message);

                const msgUpper = String(message).toUpperCase();
                const topicUpper = String(topic).toUpperCase();
                const codeUpper = String(bookingCode || '').toUpperCase();
                const refUpper = String(referenceId || '').toUpperCase();

                const isTarget =
                    (codeUpper && (topicUpper.includes(codeUpper) || msgUpper.includes(codeUpper))) ||
                    (refUpper && (topicUpper.includes(refUpper) || msgUpper.includes(refUpper))) ||
                    topicUpper.includes('QR.PAYMENT');

                if (isTarget) {
                    try {
                        const parsed = JSON.parse(message);
                        const st = String(parsed.data?.status || parsed.status || parsed.payment_status || '').toUpperCase();
                        const evt = String(parsed.event || '').toLowerCase();

                        if (['SUCCEEDED', 'PAID', 'SUCCESS', 'COMPLETED', 'SETTLED'].includes(st) || evt === 'qr.payment') {
                            console.log('✅ Payment succeeded via MQTT push event!');
                            this.markCartInvoicePaid();
                        }
                    } catch (e) {
                        if (['SUCCEEDED', 'PAID', 'SUCCESS', 'SETTLED'].some(k => msgUpper.includes(k))) {
                            console.log('✅ Payment succeeded via MQTT text push!');
                            this.markCartInvoicePaid();
                        }
                    }
                }
            });
        } catch (err) {
            console.warn('MQTT init skipped/error:', err);
        }
    }

    private markCartInvoicePaid(): void {
        if (this.cartInvoiceData) {
            this.cartInvoiceData.isPaid = true;
            this.cartInvoiceData.isPendingPayment = false;
            this.cartInvoiceData.status = 'PAID / LUNAS (VERIFIED)';
        }
        this.stopPaymentPolling();
    }

    private paymentPollingTimer: any = null;

    startPaymentPolling(bookingCode: string, refId?: string): void {
        this.stopPaymentPolling();
        if (!bookingCode && !refId) return;

        // Subscribe to MQTT WebSocket for instant push notifications (Zero HTTP request looping)
        this.subscribeCartPaymentMqtt(bookingCode, refId);
    }

    stopPaymentPolling(): void {
        if (this.paymentPollingTimer) {
            clearInterval(this.paymentPollingTimer);
            this.paymentPollingTimer = null;
        }
        if (this.cartMqttSubscription) {
            this.cartMqttSubscription.unsubscribe();
            this.cartMqttSubscription = undefined;
        }
    }

    closeCartInvoiceModal(): void {
        this.stopPaymentPolling();
        this.isCartInvoiceModalOpen = false;
        this.cartService.clearCart();
    }

    async printCartInvoice(): Promise<void> {
        if (!this.cartInvoiceData?.bookingCode) {
            if (typeof window !== 'undefined') window.print();
            return;
        }

        try {
            const bookingCode = this.cartInvoiceData.bookingCode;
            const blob = await this.apiService.downloadBlob(`/api/v1/front/public/checkout/bookings/${bookingCode}/invoice-pdf`, false);
            
            if (typeof window !== 'undefined') {
                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `invoice-${bookingCode}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            }
        } catch (error) {
            console.error('Failed to download PDF:', error);
            if (typeof window !== 'undefined') window.print();
        }
    }


    sendCartInvoiceWhatsApp():
        void {

        if (
            !this.cartInvoiceData
        ) {
            return;
        }


        const itemsList =
            this.cartInvoiceData
                .items
                .map(
                    (
                        item: any,
                        idx: number
                    ) =>
                        `${idx + 1}. *${item.name}*\n` +
                        `   Jumlah: ${item.qty}x\n` +
                        `   Subtotal: ${this.cartService.formatCurrency(
                            item.price *
                            item.qty
                        )}`
                )
                .join(
                    '\n\n'
                );


        let paymentDetailWA =
            '';


        if (
            this.cartInvoiceData
                .paymentOption ===
            'dp'
        ) {

            paymentDetailWA =
                `*NOMINAL DP ${this.cartInvoiceData.dpPercentage}%: ${this.cartService.formatCurrency(
                    this.cartInvoiceData.payAmount
                )}*\n` +

                `*Sisa Pelunasan: ${this.cartService.formatCurrency(
                    this.cartInvoiceData.remainingAmount
                )}*\n\n`;

        } else if (
            this.cartInvoiceData
                .paymentOption ===
            'quotation'
        ) {

            if (
                this.cartInvoiceData
                    .negotiationPrice
            ) {

                paymentDetailWA =
                    `*Target Budget / Negosiasi Diajukan: ${this.cartService.formatCurrency(
                        this.cartInvoiceData.negotiationPrice
                    )}*\n` +

                    (
                        this.cartInvoiceData
                            .negotiationNotes
                            ? `*Alasan Negosiasi:* ${this.cartInvoiceData.negotiationNotes}\n`
                            : ''
                    ) +

                    '\n';

            } else {

                paymentDetailWA =
                    '*Permintaan: Surat Penawaran Resmi (Quotation Proposal)*\n\n';
            }
        }


        const message =
            `*PEMESANAN LAYANAN VISIDEA STUDIO*\n` +

            `*No. Invoice:* ${this.cartInvoiceData.invoiceNumber}\n` +

            `*Tanggal:* ${this.cartInvoiceData.invoiceDate}\n\n` +

            `*Data Pemesan:*\n` +

            `• Nama: ${this.cartInvoiceData.customerName}\n` +

            `• Email: ${this.cartInvoiceData.customerEmail}\n` +

            `• WhatsApp: ${this.cartInvoiceData.customerPhone}\n` +

            `• Tanggal Acara: ${this.cartInvoiceData.eventDate}\n` +

            `• Lokasi Acara: ${this.cartInvoiceData.eventLocation}\n` +

            (
                this.cartInvoiceData.notes &&
                    this.cartInvoiceData.notes !==
                    '-'
                    ? `• Catatan: ${this.cartInvoiceData.notes}\n`
                    : ''
            ) +

            `\n*Opsi Pembayaran:* *${this.cartInvoiceData.paymentTypeLabel}*\n` +

            `\n*Rincian Pesanan:*\n${itemsList}\n\n` +

            `*TOTAL KESELURUHAN:* *${this.cartService.formatCurrency(
                this.cartInvoiceData.totalAmount
            )}*\n` +

            paymentDetailWA +

            `Halo Visidea Studio, saya ingin mengonfirmasi pemesanan dan pengiriman invoice ke email saya (${this.cartInvoiceData.customerEmail}). Mohon diproses. Terima kasih!`;


        const url =
            `https://wa.me/${this.phone}?text=${encodeURIComponent(
                message
            )}`;


        window.open(
            url,
            '_blank'
        );
    }


    // =========================================================
    // SCROLL
    // =========================================================

    scrollToSection(
        sectionId: string
    ): void {

        this.isDropdownOpen =
            false;

        this.isMobileMenuOpen =
            false;


        if (
            !this.isHomePage
        ) {

            this.router
                .navigate(['/'])
                .then(() => {

                    setTimeout(
                        () => {

                            this.scrollToElement(
                                sectionId
                            );
                        },
                        100
                    );
                });

        } else {

            this.scrollToElement(
                sectionId
            );
        }
    }


    private scrollToElement(
        elementId: string
    ): void {

        const element =
            document.getElementById(
                elementId
            );


        if (element) {

            element.scrollIntoView({
                behavior:
                    'smooth',

                block:
                    'start',

                inline:
                    'nearest',
            });
        }
    }


    // =========================================================
    // CAROUSEL METHODS
    // =========================================================

    startAutoSlide():
        void {

        this.autoSlideInterval =
            setInterval(
                () => {

                    this.nextSlide();
                },
                5000
            );
    }


    stopAutoSlide():
        void {

        if (
            this.autoSlideInterval
        ) {

            clearInterval(
                this.autoSlideInterval
            );
        }
    }


    nextSlide(): void {

        this.triggerSlideAnimation(
            () => {

                this.currentSlide =
                    (
                        this.currentSlide +
                        1
                    ) %
                    this.slides.length;
            }
        );
    }


    prevSlide(): void {

        this.triggerSlideAnimation(
            () => {

                this.currentSlide =
                    this.currentSlide ===
                        0
                        ? this.slides
                            .length -
                        1
                        : this.currentSlide -
                        1;
            }
        );
    }


    goToSlide(
        index: number
    ): void {

        if (
            index !==
            this.currentSlide
        ) {

            this.triggerSlideAnimation(
                () => {

                    this.currentSlide =
                        index;
                }
            );


            this.stopAutoSlide();

            this.startAutoSlide();
        }
    }


    triggerSlideAnimation(
        callback: () => void
    ): void {

        this.isSliding =
            true;


        setTimeout(
            () => {

                callback();


                setTimeout(
                    () => {

                        this.playVideo();
                    },
                    50
                );


                setTimeout(
                    () => {

                        this.isSliding =
                            false;
                    },
                    800
                );

            },
            50
        );
    }


    getCurrentSlide() {
        return (
            this.slides[this.currentSlide] ||
            this.slides[0] || {
                image: '/assets/visidea/digital-invitation.MOV',
                title: '',
                description: '',
                link_url: '',
                cta_text: ''
            }
        );
    }


    // =========================================================
    // WHATSAPP
    // =========================================================

    phone =
        '6282260084847';


    message =
        'Halo, saya tertarik untuk memesan PhotoBooth. Bisa bantu saya dengan informasi lebih lanjut mengenai paket ini? Terima kasih!';


    get whatsappUrl(): string {
        const encodedMessage = encodeURIComponent(this.message);
        return `https://wa.me/${this.phone}?text=${encodedMessage}`;
    }


    whatsapp(): void {
        window.open(
            this.whatsappUrl,
            '_blank'
        );
    }
}
